import stripHTML from 'Utils/strip-html';
import unescape from 'lodash/unescape';

export default (string) => unescape(stripHTML(string));
